import { QueryRecord } from './../../../../API';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '../../../shared/services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Engagements, GetQueryRecordQuery, GetQueryRecordQueryVariables } from '../../../../API';
import { GetQueryRecord } from '../../../../graphql/queries';
import { ApiService } from '../../../shared/services/api.service';
import { AppService } from '../../../shared/services/app.service';
import { takeUntil, distinctUntilChanged, Subject } from 'rxjs';

@Component({
  selector: 'app-query-result',
  templateUrl: './query-result.component.html',
  styleUrl: './query-result.component.scss',
})
export class QueryResultComponent implements OnInit, OnDestroy {
  queryId!: string;
  queryRecord!: QueryRecord;
  private destroy$ = new Subject<void>();

  readonly viewQueryResult: string[] = ['app.dcr-portal.query-result.view'];

  constructor(
    public authService: AuthService,
    private appService: AppService,
    private nzMessageService: NzMessageService,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnDestroy(): void {
    this.queryId = '';
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.queryId = this.route.snapshot.paramMap.get('queryId') ?? '';
    if (!this.queryId) {
      this.nzMessageService.error('Invalid QueryId. Failed to fetch query record');
      this.redirectToHistory();
      return;
    }

    /** subscribe for engagement changes */
    this.appService.activeEngagement$
      .pipe(
        takeUntil(this.destroy$),
        distinctUntilChanged((prev, curr) => prev.engagement !== curr.engagement),
      )
      .subscribe((engagements: Engagements) => {
        this.getQueryRecord(this.queryId!, engagements.engagement);
      });
  }

  getQueryRecord(queryId: string, engagementName: string) {
    this.apiService
      .query<GetQueryRecordQuery, GetQueryRecordQueryVariables>(GetQueryRecord, {
        engagementId: engagementName!,
        queryId: queryId!,
      })
      .then((result) => {
        const queryRecord = result.data?.GetQueryRecord;
        if (queryRecord) {
          this.queryRecord = queryRecord;
        } else {
          this.nzMessageService.error('Failed to fetch query record');
        }
      })
      .catch((error) => {
        this.nzMessageService.error(error?.message ?? 'Failed to fetch query record');
      });
  }

  redirectToHistory() {
    this.router.navigate(['/query'], {
      queryParams: { tabIndex: 1 },
    });
  }
}
